import axios from 'axios'
import { Filter } from '../../../components/_WMS/FilterComponent'
import { ApiConfig } from '../../../config/api'
import { GenericOrderBy } from '../../../components/_EOS/Table'
import { Asn } from '../../../interfaces/Asn/Asn'
import { eTypeAsnProcess } from '../../../enums/eTypeAsnProcess'

export const putReceiveASN = (asnId: number, userId: number | undefined) => {
  const url = new URL(`${ApiConfig.InboundApi}/ReceiveAsn`)

  return axios.put(url.toString(), { asnId, userId })
}

export const getReturnAsn = (
  filters?: Filter[],
  orderBy?: GenericOrderBy<Asn>,
  page = 0,
  pageSize = 5
) => {
  const url = new URL(`${ApiConfig.AsnApi}`)

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())
  url.searchParams.set('TypeAsnProcessId', eTypeAsnProcess.Return.toString())

  if (filters) {
    filters.forEach((element) => {
      url.searchParams.append(element.key, element.value.toString())
    })
  }

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  return axios.get(url.toString())
}
